import { __assign, __awaiter, __decorate, __extends, __generator, __metadata, __spreadArray } from "tslib";
import * as React from 'react';
import { Components, Utils, Misc, Validation } from '@singularsystems/neo-core';
import { observer } from 'mobx-react';
import FileUploadButton from './FileUploadButton';
import { FileContext } from './FileContext';
import { ProgressBar, Button, FileDropArea } from '../_Exports';
import ComponentBase from '../ComponentBase';
import { BindPropsHelper } from '../PropTypes';
import { makeObservable, observable } from 'mobx';
/**
 * The file manager component manages uploading, and binding of files to a model.
 */
var FileInput = /** @class */ (function (_super) {
    __extends(FileInput, _super);
    function FileInput(props) {
        var _this = _super.call(this, props) || this;
        _this.gettingDownloadUrl = false;
        makeObservable(_this);
        return _this;
    }
    FileInput.prototype.render = function () {
        var splitProps = BindPropsHelper.normaliseEditorProps(this, this.props);
        var fileProps;
        if (splitProps.fileProps) {
            // Part of a form group.
            fileProps = this.props.fileProps;
            if (this.props.bind) {
                fileProps.bind = this.props.bind;
            }
            ;
        }
        else {
            fileProps = this.props;
        }
        if (!this.fileManager) {
            if (this.context.fileManager) {
                this.fileManager = this.context.fileManager;
            }
            else {
                this.fileManager = new Components.BoundFileManager(fileProps.uploadEndpoint, fileProps);
            }
        }
        else {
            this.fileManager.options = fileProps;
        }
        if (!this.fileManager.uploadEndpoint) {
            throw Error("File input requires an uploadEndpoint.");
        }
        if (!this.fileManager.options.bind) {
            throw Error("File input requires a bind property.");
        }
        var displayInfo = this.fileManager.options.bind.validator.getDisplayState(Validation.DisplayMode.Always);
        var domProps = { className: "form-control" };
        displayInfo.applyToDom(domProps, !splitProps.inGroup);
        if (this.fileManager.isUploading || this.gettingDownloadUrl) {
            return this.renderBusy(fileProps);
        }
        else {
            if (this.fileManager.options.bind.value) {
                return this.renderSelected(fileProps, splitProps.editor, domProps);
            }
            else {
                return this.renderEmpty(fileProps, splitProps.editor, domProps);
            }
        }
    };
    FileInput.prototype.getFileDisplayComponent = function (props, domProps) {
        var _this = this;
        var options = this.fileManager.options;
        if (props.downloadEndpoint || props.downloadEndpointAsync) {
            var downloadLinkText = void 0;
            var fileName = "file";
            if (options.fileDescriptorProperty) {
                var fileDesciptor = options.fileDescriptorProperty.value;
                if (fileDesciptor) {
                    if (typeof fileDesciptor === "string") {
                        fileName = fileDesciptor;
                    }
                    else {
                        fileName = fileDesciptor.fileName;
                    }
                }
            }
            if (props.downloadLinkText) {
                downloadLinkText = props.downloadLinkText.format(fileName);
            }
            else {
                downloadLinkText = fileName;
            }
            if (props.downloadEndpointAsync) {
                return React.createElement("a", __assign({}, domProps, { href: "/", onClick: function (e) { return _this.onDownloadLinkClicked(e, props); } }), downloadLinkText);
            }
            else {
                var downloadPath = void 0;
                if (typeof props.downloadEndpoint === "string") {
                    downloadPath = props.downloadEndpoint;
                }
                else {
                    downloadPath = props.downloadEndpoint(options.bind.value);
                }
                return React.createElement("a", __assign({}, domProps, { href: downloadPath }), downloadLinkText);
            }
        }
        else {
            return React.createElement("span", __assign({}, domProps), "File selected");
        }
    };
    /** Renders when the file is busy uploading. */
    FileInput.prototype.renderBusy = function (props) {
        return this.gettingDownloadUrl ?
            React.createElement("div", { className: "form-control form-control-loading" },
                React.createElement("div", { className: "spinner-border" })) :
            React.createElement(ProgressBar, { variant: "dark", type: "animated", progress: this.fileManager.uploadPercent });
    };
    /** Renders where a file has not yet been selected. */
    FileInput.prototype.renderEmpty = function (props, editorProps, domProps) {
        var buttonOptions = Utils.populatePartialWithDefaults(Utils.populatePartialWithDefaults(__assign({}, props.browseButton), Misc.Settings.fileManager.fileEditorButton), { text: "Select file", variant: "dark" });
        if (buttonOptions.menuItems) {
            // If the user supplied a custom buton menu, split the button, and remove the start seperator, since this
            // button has no menu items of its own.
            buttonOptions.splitMenu = true;
            if (buttonOptions.menuItems[0].isDivider) {
                buttonOptions.menuItems = buttonOptions.menuItems.slice(1);
            }
        }
        domProps.className += " file-placeholder";
        return (React.createElement("div", { className: "input-group file-editor" },
            React.createElement("span", __assign({}, domProps),
                React.createElement(FileDropArea, { fileManager: this.fileManager }, editorProps.placeholder || "Drag a file here")),
            React.createElement("div", { className: "input-group-append" },
                React.createElement(FileUploadButton, __assign({}, buttonOptions, { fileManager: this.fileManager })))));
    };
    /** Renders where a file has been selected. */
    FileInput.prototype.renderSelected = function (props, editorProps, domProps) {
        var _this = this;
        var append = null;
        if (editorProps.isReadOnly !== true) {
            var buttonOptions = Utils.populatePartialWithDefaults(Utils.populatePartialWithDefaults(__assign({}, props.browseButton), Misc.Settings.fileManager.fileEditorButton), { text: "Options", variant: "dark" });
            buttonOptions.menuItems = buttonOptions.menuItems ? __spreadArray([], buttonOptions.menuItems, true) : [];
            buttonOptions.menuItems.splice(0, 0, { text: props.changeFileText || "Change file", onClick: function () { return _this.fileManager.showFileDialog(); } }, { text: "Unlink file", onClick: function () { return _this.fileManager.clearFile(); } });
            append = React.createElement("div", { className: "input-group-append" },
                React.createElement(Button, __assign({}, buttonOptions)));
        }
        return (React.createElement("div", { className: "input-group file-editor" },
            this.getFileDisplayComponent(props, domProps),
            append));
    };
    FileInput.prototype.onDownloadLinkClicked = function (e, props) {
        return __awaiter(this, void 0, void 0, function () {
            var result, downloadPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        this.gettingDownloadUrl = true;
                        return [4 /*yield*/, props.downloadEndpointAsync(this.fileManager.options.bind.value)];
                    case 2:
                        result = _a.sent();
                        downloadPath = void 0;
                        if (typeof result === "string") {
                            downloadPath = result;
                        }
                        else {
                            downloadPath = result.data;
                        }
                        window.location.href = downloadPath;
                        return [3 /*break*/, 4];
                    case 3:
                        this.gettingDownloadUrl = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FileInput.contextType = FileContext;
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], FileInput.prototype, "gettingDownloadUrl", void 0);
    FileInput = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], FileInput);
    return FileInput;
}(ComponentBase));
export default FileInput;
